/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.220.0-v202610302343-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqDatasourcesApiClass {
 
   constructor() {}

  /**
   * @summary Archive a datasource
   * @param {string} id - ID of the datasource to delete
  */
  public archiveDatasource(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datasources/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/datasources/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Archive stale hosted items
   * @param {string} id - ID of the datasource to clean up
  */
  public cleanUp(
    body: models.DatasourceCleanUpInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datasources/${encodeURIComponent(String(id))}/cleanup`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/datasources/{id}/cleanup`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.DatasourceCleanUpOutputV1>;
  }

  /**
   * @summary Clear cache for all items in this datasource and their dependents.
   * @param {string} id
   * @param {boolean} [recompileFormulas=false] - If true, dependent formulas will be marked as needing recompilation in addition to having their caches cleared. This can be significantly more expensive. It is also typically not necessary because Seeq detects events that require recompilation of dependent formulas and performs the necessary recompilation automatically. Consider consulting Seeq Support before using this option.
  */
  public clearDatasourceCache(
    {
      id,
      recompileFormulas
    } : {
      id: string,
      recompileFormulas?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datasources/${encodeURIComponent(String(id))}/cache`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/datasources/{id}/cache`;

    const queryParams = {
      ['recompileFormulas']: recompileFormulas
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.DatasourceCacheClearOutputV1>;
  }

  /**
   * @summary Create a datasource
  */
  public createDatasource(
    body: models.DatasourceInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datasources`;
    const urlTemplate = `${baseUrl}/datasources`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.DatasourceOutputV1>;
  }

  /**
   * @summary Disable all connections associated with a datasource
   * @param {string} id - ID of the datasource
  */
  public disableConnections(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datasources/${encodeURIComponent(String(id))}/disable-connections`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/datasources/{id}/disable-connections`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ConnectionsOutputV1>;
  }

  /**
   * @summary Archive a datasource, its connections, and all items hosted by the datasource
   * @param {string} id - ID of the datasource to archive
  */
  public fullyArchiveDatasource(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datasources/${encodeURIComponent(String(id))}/archive`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/datasources/{id}/archive`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.JobAcceptedOutputV1>;
  }

  /**
   * @summary Get a Datasource
   * @param {string} id - ID of the datasource to retrieve
  */
  public getDatasource(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datasources/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/datasources/{id}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.DatasourceOutputV1>;
  }

  /**
   * @summary Get a collection of datasources
   * @param {string} [datasourceClass] - The datasource class, the name of the underlying source, &#x27;CSV File&#x27; for example, not specifying this parameter will return datasources of any class
   * @param {string} [datasourceId] - The datasource ID, an identifier that distinguishes a datasource from others of the same datasource class, &#x27;timeseries/salt&#x27; for example, not specifying this parameter will return datasources of any ID
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
   * @param {boolean} [includeArchived=false] - Whether archived datasources should be included
   * @param {string} [scopedTo] - The scope of the datasource
   * @param {boolean} [excludeGloballyScoped=false] - Whether globally scoped datasources should be excluded
  */
  public getDatasources(
    {
      datasourceClass,
      datasourceId,
      offset,
      limit,
      includeArchived,
      scopedTo,
      excludeGloballyScoped
    } : {
      datasourceClass?: string,
      datasourceId?: string,
      offset?: number,
      limit?: number,
      includeArchived?: boolean,
      scopedTo?: string,
      excludeGloballyScoped?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datasources`;
    const urlTemplate = `${baseUrl}/datasources`;

    const queryParams = {
      ['datasourceClass']: datasourceClass,      ['datasourceId']: datasourceId,      ['offset']: offset,      ['limit']: limit,      ['includeArchived']: includeArchived,      ['scopedTo']: scopedTo,      ['excludeGloballyScoped']: excludeGloballyScoped
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.DatasourceOutputListV1>;
  }

  /**
   * @summary Get a list of the items hosted by this datasource
   * @param {string} id - ID of the datasource
   * @param {string} [dataId] - The dataId for a specific hosted item
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
  */
  public getItemsHostedByDatasource(
    {
      id,
      dataId,
      offset,
      limit
    } : {
      id: string,
      dataId?: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datasources/${encodeURIComponent(String(id))}/items`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/datasources/{id}/items`;

    const queryParams = {
      ['dataId']: dataId,      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemPreviewListV1>;
  }

  /**
   * @summary Get a list of the data IDs in the specified datasource of signals and conditions to pre-cache.
   * @param {string} datasourceClass
   * @param {string} datasourceId
   * @param {number} [limit=10000]
   * @param {string} [previousPageLastDataId] - The data ID of the last item of the previous page, or null to fetch the first page. Only items with data IDs strictly greater than this data ID will be returned.
  */
  public getPrecachedItems(
    {
      datasourceClass,
      datasourceId,
      limit,
      previousPageLastDataId
    } : {
      datasourceClass: string,
      datasourceId: string,
      limit?: number,
      previousPageLastDataId?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (datasourceClass === null || datasourceClass === undefined) {
      throw new Error("'datasourceClass' parameter required");
    }

    if (datasourceId === null || datasourceId === undefined) {
      throw new Error("'datasourceId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datasources/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/precached-items`
      .replace('{datasourceClass}', encodeURIComponent(String(datasourceClass)))
      .replace('{datasourceId}', encodeURIComponent(String(datasourceId)));
    const urlTemplate = `${baseUrl}/datasources/{datasourceClass}/{datasourceId}/precached-items`;

    const queryParams = {
      ['limit']: limit,      ['previousPageLastDataId']: previousPageLastDataId
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.PrecachedItemsOutputV1>;
  }

  /**
   * @summary Get statistics describing the health of remote datasources
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
  */
  public getStatus(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datasources/status`;
    const urlTemplate = `${baseUrl}/datasources/status`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.DatasourceStatusOutputV1>;
  }

  /**
   * @summary Recount item totals for a datasource. Do not run while datasource is indexing
   * @param {string} id - ID of the datasource to recount
  */
  public recount(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datasources/${encodeURIComponent(String(id))}/recount`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/datasources/{id}/recount`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.DatasourceOutputV1>;
  }

}


export const sqDatasourcesApi = new sqDatasourcesApiClass();

export type sqDatasourcesApiEndpoints = {
  'archiveDatasource': {
    method: 'delete';
    path: '/datasources/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'cleanUp': {
    method: 'post';
    path: '/datasources/${encodeURIComponent(String(id))}/cleanup';
    response: models.DatasourceCleanUpOutputV1;
  };
  'clearDatasourceCache': {
    method: 'delete';
    path: '/datasources/${encodeURIComponent(String(id))}/cache';
    response: models.DatasourceCacheClearOutputV1;
  };
  'createDatasource': {
    method: 'post';
    path: '/datasources';
    response: models.DatasourceOutputV1;
  };
  'disableConnections': {
    method: 'post';
    path: '/datasources/${encodeURIComponent(String(id))}/disable-connections';
    response: models.ConnectionsOutputV1;
  };
  'fullyArchiveDatasource': {
    method: 'delete';
    path: '/datasources/${encodeURIComponent(String(id))}/archive';
    response: models.JobAcceptedOutputV1;
  };
  'getDatasource': {
    method: 'get';
    path: '/datasources/${encodeURIComponent(String(id))}';
    response: models.DatasourceOutputV1;
  };
  'getDatasources': {
    method: 'get';
    path: '/datasources';
    response: models.DatasourceOutputListV1;
  };
  'getItemsHostedByDatasource': {
    method: 'get';
    path: '/datasources/${encodeURIComponent(String(id))}/items';
    response: models.ItemPreviewListV1;
  };
  'getPrecachedItems': {
    method: 'get';
    path: '/datasources/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/precached-items';
    response: models.PrecachedItemsOutputV1;
  };
  'getStatus': {
    method: 'get';
    path: '/datasources/status';
    response: models.DatasourceStatusOutputV1;
  };
  'recount': {
    method: 'post';
    path: '/datasources/${encodeURIComponent(String(id))}/recount';
    response: models.DatasourceOutputV1;
  };
};

type ApiArchiveDatasourceResponse = models.StatusMessageBase;
type ApiarchiveDatasourceMutationParams = Parameters<typeof sqDatasourcesApi.archiveDatasource> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqDatasourcesApi.archiveDatasource>;

export function useApiArchiveDatasourceMutation(
  options?: Omit<UseMutationOptions<ApiArchiveDatasourceResponse, AxiosError<SeeqErrorData>,
    ApiarchiveDatasourceMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiArchiveDatasourceResponse, AxiosError<SeeqErrorData>,
  ApiarchiveDatasourceMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiarchiveDatasourceMutationParams) =>
      sqDatasourcesApi.archiveDatasource(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCleanUpResponse = models.DatasourceCleanUpOutputV1;
type ApicleanUpMutationParams = Parameters<typeof sqDatasourcesApi.cleanUp> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqDatasourcesApi.cleanUp>;

export function useApiCleanUpMutation(
  options?: Omit<UseMutationOptions<ApiCleanUpResponse, AxiosError<SeeqErrorData>,
    ApicleanUpMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCleanUpResponse, AxiosError<SeeqErrorData>,
  ApicleanUpMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApicleanUpMutationParams) =>
      sqDatasourcesApi.cleanUp(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiClearDatasourceCacheResponse = models.DatasourceCacheClearOutputV1;
type ApiclearDatasourceCacheMutationParams = Parameters<typeof sqDatasourcesApi.clearDatasourceCache> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqDatasourcesApi.clearDatasourceCache>;

export function useApiClearDatasourceCacheMutation(
  options?: Omit<UseMutationOptions<ApiClearDatasourceCacheResponse, AxiosError<SeeqErrorData>,
    ApiclearDatasourceCacheMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiClearDatasourceCacheResponse, AxiosError<SeeqErrorData>,
  ApiclearDatasourceCacheMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiclearDatasourceCacheMutationParams) =>
      sqDatasourcesApi.clearDatasourceCache(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateDatasourceResponse = models.DatasourceOutputV1;
type ApicreateDatasourceMutationParams = Parameters<typeof sqDatasourcesApi.createDatasource> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqDatasourcesApi.createDatasource>;
type ApicreateDatasourceMutationVariables = models.DatasourceInputV1;

export function useApiCreateDatasourceMutation(
  options?: Omit<UseMutationOptions<ApiCreateDatasourceResponse, AxiosError<SeeqErrorData>,
    ApicreateDatasourceMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateDatasourceResponse, AxiosError<SeeqErrorData>,
  ApicreateDatasourceMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApicreateDatasourceMutationVariables) =>
      sqDatasourcesApi.createDatasource(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiDisableConnectionsResponse = models.ConnectionsOutputV1;
type ApidisableConnectionsMutationParams = Parameters<typeof sqDatasourcesApi.disableConnections> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqDatasourcesApi.disableConnections>;

export function useApiDisableConnectionsMutation(
  options?: Omit<UseMutationOptions<ApiDisableConnectionsResponse, AxiosError<SeeqErrorData>,
    ApidisableConnectionsMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiDisableConnectionsResponse, AxiosError<SeeqErrorData>,
  ApidisableConnectionsMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApidisableConnectionsMutationParams) =>
      sqDatasourcesApi.disableConnections(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiFullyArchiveDatasourceResponse = models.JobAcceptedOutputV1;
type ApifullyArchiveDatasourceMutationParams = Parameters<typeof sqDatasourcesApi.fullyArchiveDatasource> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqDatasourcesApi.fullyArchiveDatasource>;

export function useApiFullyArchiveDatasourceMutation(
  options?: Omit<UseMutationOptions<ApiFullyArchiveDatasourceResponse, AxiosError<SeeqErrorData>,
    ApifullyArchiveDatasourceMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiFullyArchiveDatasourceResponse, AxiosError<SeeqErrorData>,
  ApifullyArchiveDatasourceMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApifullyArchiveDatasourceMutationParams) =>
      sqDatasourcesApi.fullyArchiveDatasource(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetDatasourceResponse = models.DatasourceOutputV1;
export function GetDatasourceQueryKey(
  params: Parameters<typeof sqDatasourcesApi.getDatasource>[0],
) {
  return ['sqDatasourcesApi', 'getDatasource', params] as const;
}

export function useApiGetDatasourceQuery(
  params: Parameters<typeof sqDatasourcesApi.getDatasource>[0],
  options?: Omit<UseQueryOptions<ApiGetDatasourceResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetDatasourceResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetDatasourceQueryKey(params),
    queryFn: () =>
      sqDatasourcesApi.getDatasource(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetDatasourcesResponse = models.DatasourceOutputListV1;
export function GetDatasourcesQueryKey(
  params: Parameters<typeof sqDatasourcesApi.getDatasources>[0],
) {
  return ['sqDatasourcesApi', 'getDatasources', params] as const;
}

export function useApiGetDatasourcesQuery(
  params: Parameters<typeof sqDatasourcesApi.getDatasources>[0],
  options?: Omit<UseQueryOptions<ApiGetDatasourcesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetDatasourcesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetDatasourcesQueryKey(params),
    queryFn: () =>
      sqDatasourcesApi.getDatasources(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetItemsHostedByDatasourceResponse = models.ItemPreviewListV1;
export function GetItemsHostedByDatasourceQueryKey(
  params: Parameters<typeof sqDatasourcesApi.getItemsHostedByDatasource>[0],
) {
  return ['sqDatasourcesApi', 'getItemsHostedByDatasource', params] as const;
}

export function useApiGetItemsHostedByDatasourceQuery(
  params: Parameters<typeof sqDatasourcesApi.getItemsHostedByDatasource>[0],
  options?: Omit<UseQueryOptions<ApiGetItemsHostedByDatasourceResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetItemsHostedByDatasourceResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetItemsHostedByDatasourceQueryKey(params),
    queryFn: () =>
      sqDatasourcesApi.getItemsHostedByDatasource(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetPrecachedItemsResponse = models.PrecachedItemsOutputV1;
export function GetPrecachedItemsQueryKey(
  params: Parameters<typeof sqDatasourcesApi.getPrecachedItems>[0],
) {
  return ['sqDatasourcesApi', 'getPrecachedItems', params] as const;
}

export function useApiGetPrecachedItemsQuery(
  params: Parameters<typeof sqDatasourcesApi.getPrecachedItems>[0],
  options?: Omit<UseQueryOptions<ApiGetPrecachedItemsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetPrecachedItemsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetPrecachedItemsQueryKey(params),
    queryFn: () =>
      sqDatasourcesApi.getPrecachedItems(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetStatusResponse = models.DatasourceStatusOutputV1;
export function GetStatusQueryKey(
  params: Parameters<typeof sqDatasourcesApi.getStatus>[0],
) {
  return ['sqDatasourcesApi', 'getStatus', params] as const;
}

export function useApiGetStatusQuery(
  params: Parameters<typeof sqDatasourcesApi.getStatus>[0],
  options?: Omit<UseQueryOptions<ApiGetStatusResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetStatusResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetStatusQueryKey(params),
    queryFn: () =>
      sqDatasourcesApi.getStatus(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiRecountResponse = models.DatasourceOutputV1;
type ApirecountMutationParams = Parameters<typeof sqDatasourcesApi.recount> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqDatasourcesApi.recount>;

export function useApiRecountMutation(
  options?: Omit<UseMutationOptions<ApiRecountResponse, AxiosError<SeeqErrorData>,
    ApirecountMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiRecountResponse, AxiosError<SeeqErrorData>,
  ApirecountMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApirecountMutationParams) =>
      sqDatasourcesApi.recount(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
